import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=2f0671ae&scoped=true&"
import script from "./FilePicker.vue?vue&type=script&lang=js&"
export * from "./FilePicker.vue?vue&type=script&lang=js&"
import style0 from "./FilePicker.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FilePicker.vue?vue&type=style&index=1&id=2f0671ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0671ae",
  null
  
)

export default component.exports